<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6032 4.5332H5.73654C5.60321 4.5332 5.48321 4.58654 5.38988 4.66654L2.05654 7.59987C1.93654 7.70654 1.86987 7.8532 1.86987 7.99987C1.86987 8.15987 1.93654 8.2932 2.05654 8.39987L5.38988 11.3332C5.48321 11.4132 5.61654 11.4665 5.73654 11.4665H13.6032C13.8965 11.4665 14.1365 11.2265 14.1365 10.9332V5.06654C14.1365 4.7732 13.8965 4.5332 13.6032 4.5332ZM13.0699 10.3999H5.93654L3.20321 7.99987L5.93654 5.59987H13.0699V10.3999ZM5.49653 7.38654C5.65653 7.22654 5.88321 7.1332 6.10988 7.1332C6.33655 7.1332 6.56321 7.22654 6.72321 7.38654C6.88321 7.54654 6.97655 7.7732 6.97655 7.99987C6.97655 8.22654 6.88321 8.4532 6.72321 8.6132C6.56321 8.7732 6.33655 8.86654 6.10988 8.86654C5.88321 8.86654 5.65653 8.7732 5.49653 8.6132C5.33653 8.4532 5.24321 8.22654 5.24321 7.99987C5.24321 7.7732 5.33653 7.54654 5.49653 7.38654Z" :fill="fill"/>
  </svg>

</template>

<script>
  export default {
    name: 'bookmarkIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>
